var CommonApiEndpoints;
(function (CommonApiEndpoints) {
    CommonApiEndpoints["workspaceTemplates"] = "workspaceTemplates";
    CommonApiEndpoints["parameters"] = "parameters";
    CommonApiEndpoints["risktemplates"] = "risktemplates";
    CommonApiEndpoints["licenses"] = "licenses";
    CommonApiEndpoints["version"] = "version";
    CommonApiEndpoints["metric"] = "metric";
    CommonApiEndpoints["users"] = "users";
})(CommonApiEndpoints || (CommonApiEndpoints = {}));
var PointScalingApiEndpoints;
(function (PointScalingApiEndpoints) {
    PointScalingApiEndpoints["workspaces"] = "workspaces";
    PointScalingApiEndpoints["layouts"] = "layouts";
    PointScalingApiEndpoints["tags"] = "tags";
    PointScalingApiEndpoints["bioreactors"] = "bioreactors";
})(PointScalingApiEndpoints || (PointScalingApiEndpoints = {}));
var RecipeScalingApiEndpoints;
(function (RecipeScalingApiEndpoints) {
    RecipeScalingApiEndpoints["workspaces"] = "rs/workspaces";
    RecipeScalingApiEndpoints["cellModels"] = "rs/cellmodels";
    RecipeScalingApiEndpoints["recipes"] = "rs/recipes";
    RecipeScalingApiEndpoints["tags"] = "rs/tags";
    RecipeScalingApiEndpoints["processData"] = "rs/processdata";
    RecipeScalingApiEndpoints["simulations"] = "rs/simulations";
    RecipeScalingApiEndpoints["bioreactors"] = "rs/bioreactors";
})(RecipeScalingApiEndpoints || (RecipeScalingApiEndpoints = {}));
export { CommonApiEndpoints, PointScalingApiEndpoints, RecipeScalingApiEndpoints };
